import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { getPhysicalDamage } from "../state/physicalDamage/actions";
import { useAppInsights } from "../utils/telemetry/AppInsights";

const usePhysicalDamage = (caseId, physicalDamageId, enabled = true) => {
  const { trackException } = useAppInsights();
  const [initialized, setInitialized] = useState(false);
  const dispatch = useDispatch();
  const physicalDamage = useSelector(state => state.physicalDamage);
  const attemptedPhysicalDamageId = useRef(null);

  const loadedPhysicalDamageId =
    physicalDamage.data && physicalDamage.data.id;

  useEffect(() => {
    if (!enabled) return;

    if (loadedPhysicalDamageId === physicalDamageId) {
      setInitialized(true);
      return;
    }

    if (attemptedPhysicalDamageId.current === physicalDamageId) return;
    attemptedPhysicalDamageId.current = physicalDamageId;
    setInitialized(false);

    dispatch(
      getPhysicalDamage({
        caseId,
        physicalDamageId,
        onFinish: success => {
          if (!success) {
            trackException(
              `Failed to get physical damage data from: ${physicalDamageId} at case: ${caseId}`
            );
          }
          setInitialized(true);
        }
      })
    );
  }, [
    caseId,
    dispatch,
    enabled,
    physicalDamageId,
    loadedPhysicalDamageId,
    trackException
  ]);

  return { ...physicalDamage, initialized };
};

export default usePhysicalDamage;
